import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AboutUsComponent} from '../about-us/about-us.component';
import {CoursesComponent} from './courses.component';

const routes: Routes = [
  {
    path: 'courses',
    component: CoursesComponent,
    data: {animation: 'courses'}
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoursesRoutingModule { }
